import { inject, injectable } from "inversify";
import {
  ClientPortalDocumentFiltersModel,
  ClientPortalDocumentInstanceModel,
  ClientPortalDocumentModel,
  DocumentAttachmentModel,
  ICPLClientPortalDocumentsClient,
  IntSelectModel,
} from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalDocumentsService {
  getDocumentInstances(documentID: string): Promise<ClientPortalDocumentInstanceModel[]>;
  getDocuments(filterModel: ClientPortalDocumentFiltersModel): Promise<ClientPortalDocumentModel[]>;
  getDocumentAttachments(documentID: string): Promise<DocumentAttachmentModel[]>;
  downloadAttachmentFile(attachmentID: number): Promise<File>;
  downloadDocumentFile(documentID: string, filePath: string): Promise<File>;
  getDocumentTypes(): Promise<IntSelectModel[]>;
}

@injectable()
export class ClientPortalDocumentsService implements IClientPortalDocumentsService {
  @inject(SERVICE_TYPES.CPLClientPortalDocumentsClient)
  cplClientPortalDocumentsClient!: ICPLClientPortalDocumentsClient;

  getDocuments(filterModel: ClientPortalDocumentFiltersModel): Promise<ClientPortalDocumentModel[]> {
    return this.cplClientPortalDocumentsClient.getDocuments(filterModel);
  }

  getDocumentInstances(documentID: string): Promise<ClientPortalDocumentInstanceModel[]> {
    return this.cplClientPortalDocumentsClient.getDocumentInstances(documentID);
  }

  getDocumentAttachments(documentID: string): Promise<DocumentAttachmentModel[]> {
    return this.cplClientPortalDocumentsClient.getDocumentAttachments(documentID);
  }

  async downloadAttachmentFile(attachmentID: number): Promise<File> {
    const fileResponse = await this.cplClientPortalDocumentsClient.downloadAttachmentFile(attachmentID);
    return new File([fileResponse.data], fileResponse.fileName!);
  }

  async downloadDocumentFile(documentID: string, filePath: string): Promise<File> {
    const fileResponse = await this.cplClientPortalDocumentsClient.downloadDocumentFile(documentID, filePath);
    return new File([fileResponse.data], fileResponse.fileName!);
  }

  async getDocumentTypes(): Promise<IntSelectModel[]> {
    return this.cplClientPortalDocumentsClient.getDocumentTypeSelectModels();
  }
}
